var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirdropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161648"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3930",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5690FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7 12H17M17 12L12.8333 8M17 12L12.8333 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropArrow);
export default __webpack_public_path__ + "static/media/airdropArrow.58a28a7cf381d838ea96735bf8eaedc5.svg";
export { ForwardRef as ReactComponent };